import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";
import { ArrowRight } from "lucide-react";
import Hero from "@/components/home/Hero";
import MaterialsMarquee from "@/components/home/MaterialsMarquee";
import HowItWorks from "@/components/home/HowItWorks";
import TwoSides from "@/components/home/TwoSides";
import RatesPreview from "@/components/home/RatesPreview";
import WhyItMatters from "@/components/home/WhyItMatters";
import NewsPreview from "@/components/home/NewsPreview";
import FinalCta from "@/components/home/FinalCta";
import FaqList from "@/components/FaqList";
import Reveal from "@/components/Reveal";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <MaterialsMarquee />
      <HowItWorks />
      <TwoSides />
      <RatesPreview />
      <WhyItMatters />
      <NewsPreview />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="home-faq-section">
        <Reveal className="text-center">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)]">{t("Questions")}</div>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold">{t("Good to know")}</h2>
        </Reveal>
        <div className="mt-10"><FaqList limit={5} /></div>
        <div className="mt-6 text-center">
          <Link to="/learn" className="inline-flex items-center gap-2 font-semibold text-[var(--leaf-dark)] link-u" data-testid="home-faq-more">{t("More answers & segregation guide")} <ArrowRight size={16} /></Link>
        </div>
      </section>
      <FinalCta />
    </div>
  );
}
